import { openExternalUrl } from "./openExternalUrl";
import { resolveEditInBrowserUrl } from "./resolveEditInBrowserUrl";
import {
  buildOneDriveOpenFileUri,
  openInOneDriveSyncApp,
} from "./openInDesktopApp";
import { openDocumentPreferDesktop } from "./openDocumentPreferDesktop";
import {
  isImageWorkingDocument,
  isVideoWorkingDocument,
  isAudioWorkingDocument,
  isTextWorkingDocument,
  isEmailWorkingDocument,
} from "../functions/helperMethod";
import { logger } from "./logger";

/**
 * Opens a Working Document the same way as the Working Documents "Edit" action:
 * media/text/email → OneDrive sync app (desktop default app); Office → desktop then browser.
 *
 * @param {object | null | undefined} file Graph-like drive item (webUrl, webDavUrl, name, sharepointIds, …)
 * @param {{ logLabel?: string }} [options]
 */
export function openWorkingDocumentFile(
  file,
  { logLabel = "openWorkingDocumentFile" } = {},
) {
  if (!file) return;

  if (
    isImageWorkingDocument(file) ||
    isVideoWorkingDocument(file) ||
    isAudioWorkingDocument(file) ||
    isTextWorkingDocument(file) ||
    isEmailWorkingDocument(file)
  ) {
    const userEmail = localStorage.getItem("userPrincipalName");
    const userId = localStorage.getItem("userId");
    logger.info(
      logLabel,
      {
        fileId: file?.id,
        fileName: file?.name,
        hasSharepointIds: Boolean(file?.sharepointIds),
        uri: buildOneDriveOpenFileUri(file, { userEmail, userId }),
        target: "onedrive-sync-app",
      },
      "DESKTOP",
    );
    openInOneDriveSyncApp(file, {
      userEmail,
      userId,
      onUnavailable: () => {
        const browserUrl = file?.webUrl ?? file?.WebUrl;
        if (browserUrl) {
          openExternalUrl(resolveEditInBrowserUrl(String(browserUrl)));
        }
      },
    });
    return;
  }

  openDocumentPreferDesktop(file, { logLabel });
}
